export default function VMAMasterVendorDirectiveController(
  $q,
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  editMasterProductDialog,
  editMasterVendorDialog,
  loaderService,
  ssDialogService,
  vmDataService
) {
  const vm = this;
  vm.canExpand = true;
  vm.isExpanded = false;
  vm.hasData = false;
  vm.masterVendor = $scope.vmaMasterVendorVM.masterVendor;
  vm.currentSavedName = vm.masterVendor.name;
  vm.handleExpandMasterVendorClick = handleExpandMasterVendorClick;
  vm.handleAddProductClick = handleAddProductClick;
  vm.handleEditClick = handleEditClick;
  vm.handleDeleteClick = handleDeleteClick;
  _activate();

  function _activate() {
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshVMAMasterVendor', (event, data) => {
      if (data.masterVendorId === vm.masterVendor.masterVendorId) {
        _refreshMasterProducts();
      }
    });
  }

  function _refreshMasterProducts() {
    const dfdItem = $q.defer();

    loaderService.showViewLoader = true;
    vmDataService.getMasterProducts(
      vm.masterVendor.masterVendorId
    ).then((response) => {
      vm.masterVendor.masterProducts = response.data.result;
      vm.masterVendor.hasProductsData = true;
      loaderService.showViewLoader = false;
      dfdItem.resolve();
    });

    return dfdItem.promise;
  }

  function handleExpandMasterVendorClick() {
    if (vm.canExpand) {
      if (vm.hasData) {
        vm.isExpanded = !vm.isExpanded;
      } else {
        _refreshMasterProducts().then(() => {
          vm.hasData = true;
          vm.isExpanded = true;
        });
      }
    }
  }

  function handleAddProductClick($event) {
    ssDialogService.dialogs.vendorManagement.editMasterProductDialog = ssDialogService.alert(
      editMasterProductDialog.getOptions($event, {
        masterProduct: {
          masterVendorId: vm.masterVendor.masterVendorId,
          masterProductId: 0,
        }
      })
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.editMasterProductDialog);
  }

  function handleEditClick($event) {
    ssDialogService.dialogs.vendorManagement.editMasterVendorDialog = ssDialogService.alert(
      editMasterVendorDialog.getOptions($event, {
        masterVendor: vm.masterVendor,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.editMasterVendorDialog);
  }

  function handleDeleteClick($event) {
    ssDialogService.dialogs.auditTrail.deleteMasterVendorConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Master Vendor?',
        message: `Are you sure you want to delete Master Vendor "${vm.masterVendor.name}"?`,
        handleYesClick: () => {
          _handleConfirmDeleteClick();
        },
        handleNoClick: () => {
          _handleCancelDeleteClick();
        },
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteMasterVendorConfirmDialog);
  }

  function _handleConfirmDeleteClick() {
    vmDataService.deleteMasterVendor(
      vm.masterVendor.masterVendorId
    ).then((response) => {
      if (response.status === 200) {
        alerts.success(`The Master Vendor "${vm.masterVendor.name}" was successfully deleted.`);
        $rootScope.$broadcast('refreshVMAVendors');
        _closeDeleteDialog();
      } else {
        alerts.error('An error occurred while deleting the Master Vendor.');
      }
    });
  }

  function _handleCancelDeleteClick() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteMasterVendorConfirmDialog);
  }
}

VMAMasterVendorDirectiveController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'confirmDialog',
  'editMasterProductDialog',
  'editMasterVendorDialog',
  'loaderService',
  'ssDialogService',
  'vmDataService'
];
